import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classNames from 'classnames';
import Icon from '@helsenorge/designsystem-react/components/Icon';
import X from '@helsenorge/designsystem-react/components/Icons/X';
import { useIsMobileBreakpoint } from '@helsenorge/designsystem-react/hooks/useIsMobileBreakpoint';
import { mergeRefs } from '@helsenorge/designsystem-react/utils/refs';
import { usePseudoClasses } from '@helsenorge/designsystem-react';
import styles from './close.module.scss';
// @todo Erstatt med komponent fra designsystemet når den støtter type og value
const Close = forwardRef(function ButtonForwardedRef(props, ref) {
    const { small, testId, ariaLabel = 'Lukk', onClick, className, color = 'blueberry', type = 'button', value } = props;
    const { refObject, isHovered } = usePseudoClasses();
    const iconSize = useIsMobileBreakpoint() || small ? 38 : 48;
    let iconColor;
    if (color === 'black') {
        iconColor = 'black';
    }
    else if (color === 'plum') {
        iconColor = 'var(--core-color-plum-700)';
    }
    else {
        iconColor = 'var(--color-action-graphics-dark-normal)';
    }
    const closeClasses = classNames(styles.close, { [styles['close--small']]: small }, className);
    return (_jsx("button", { ref: mergeRefs([ref, refObject]), "data-testid": testId, className: closeClasses, "aria-label": ariaLabel, onClick: onClick, type: type, value: value, children: _jsx("span", { className: classNames(styles['close__inner-container'], {
                [styles['close__inner-container--small']]: small,
                [styles['close__inner-container--plum']]: color == 'plum',
            }), children: _jsx(Icon, { svgIcon: X, color: iconColor, size: iconSize, isHovered: isHovered }) }) }));
});
export default Close;
